#!/usr/bin/env node
/* Enable stacees sidebar accordion transitions after first paint */
(function () {
  function arm() {
    document.querySelectorAll('.collection-stacees-plp').forEach(function (el) {
      el.classList.add('st-sidebar-ready');
    });
  }
  if (document.readyState === 'complete') {
    requestAnimationFrame(arm);
  } else {
    window.addEventListener('load', function () {
      requestAnimationFrame(arm);
    });
  }
})();
